import { Collection } from '@/state/Collection';
import { _RESIDENTS } from "@/state";

import { InvitationsRoutes } from '@/repository/tenant';
const { GetAllTenantInvitations, CreateTenantInvitations, CreateBulkTenantInvitations, UpdateBulkTenantInvitations, DeleteTenantInvitation, DeleteAllTenantInvitations, ResendTenantInvitation } = InvitationsRoutes;

// Export this module
export default {
	namespaced: true,
	state: {
		all: [],
		_all: new Collection({ statePath: 'tenant.invitations.all' })
	},
	actions: {

		// Get all invitations on this to tenant
		async index({ commit }, args) {
			try {
				let { page, per_page } = Object.assign({}, args)
				let res = await GetAllTenantInvitations({ page, per_page });
				commit('SET_TENANT_INVITATION_LIST', res.data);
				return res;
			}
			catch (error) {
				console.error('Tenant Invitations could not be indexed.', error);
				throw error;
			}
		},

		async indexNextPage({ commit }) {
			try {
				if (_RESIDENTS().pagination.isLastPage()) {
					return;
				}
				let res = await GetAllResidents({ page: _RESIDENTS().pagination.nextPage() })
				commit('APPEND_MULTIPLE_RESIDENTS_TO_LIST', res.data);
			}
			catch (error) {
				console.error('Next page of invitations could not be indexed.', error);
				throw error;
			}
		},

		async create({ state, commit }, { data }) {
			try {
				let res = await CreateTenantInvitations({ data });
				commit('APPEND_MULTIPLE_TENANT_INVITATIONS_TO_LIST', res.data)
				return res
			}
			catch (error) {
				console.error('Tenant Invitations could not be created.', error);
				throw error;
			}
		},

		async createBulk({ state, commit }, { emails }) {
			try {
				let res = await CreateBulkTenantInvitations({ emails });
				commit('APPEND_MULTIPLE_TENANT_INVITATIONS_TO_LIST', res.data)
				return res
			}
			catch (error) {
				console.error('Tenant Invitations could not be created.', error);
				throw error;
			}
		},

		async update({ state, commit }, { data }) {
			try {
				let res = await UpdateBulkTenantInvitations({ data });
				commit('APPEND_MULTIPLE_TENANT_INVITATIONS_TO_LIST', res.data)
				return res
			}
			catch (error) {
				console.error('Tenant Invitations could not be updated.', error);
				throw error;
			}
		},

		async resend({ commit }, { invitation }) {
			try {
				let res = await ResendTenantInvitation({ invitation });
				return res;
			}
			catch (error) {
				console.error('Tenant Invitation could not be resent.', error);
				throw error;
			}
		},

		async deleteAll({ commit }) {
			try {
				await DeleteAllTenantInvitations();
				commit('SET_TENANT_INVITATION_LIST', []);
			}
			catch (error) {
				console.error('All Tenant Invitations could not be deleted.', error);
				throw error;
			}

		},

		async delete({ commit }, { invitation }) {
			try {
				let res = await DeleteTenantInvitation({ invitation });
				if (res.status !== 204) {
					throw 'Problem occurred when deleting Tenant Invitation.';
				}
				commit('DELETE_TENANT_INVITATION', invitation)
				return true;
			}
			catch (error) {
				console.error('Tenant Invitation could not be deleted.', error);
				throw error;
			}
		}

	},
	mutations: {
		SET_TENANT_INVITATION_LIST(state, data) {
			state._all.items.set(data).commitToState()
		},
		APPEND_MULTIPLE_TENANT_INVITATIONS_TO_LIST(state, objs) {
			state._all.items.appends(objs, false).commitToState();
		},
		DELETE_TENANT_INVITATION(state, obj) {
			state._all.items.deleteItem(obj).commitToState();
		},
	}
}